
import Vue from "vue"
import CompanySearch from "../components/company/CompanySearch.vue"

export default Vue.extend({
  name: "CompanyForm",
  components: {
    CompanySearch
  },
  created() {
    document.title = this.$vuetify.lang.t("$vuetify.tab_titles.company_create")
  },
  computed: {
    shouldOpenFormOnMount(): boolean {
      const query: any = (this as any).$route && (this as any).$route.query ? (this as any).$route.query : {}
      return query.openForm === '1'
    }
  },
})
